/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ObservableQuery } from "@apollo/client";
import { Cell } from "react-table";
import { CustomerBasic } from "~/generated/graphql";
import { Actions } from "~/views/customers/Actions";

type CustomersListColumnsProps = {
  refetch: ObservableQuery["refetch"];
};

export const CustomersListColumns = ({
  refetch,
}: CustomersListColumnsProps) => [
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
  },
  {
    Header: "Min. RPO (hours)",
    accessor: "backupPoliciesBoundary.minRPOInHours",
    disableSortBy: true,
  },
  {
    Header: "Max. Primary Retention Quantity",
    accessor: "backupPoliciesBoundary.maxPrimarySnapshotRetentionQuantity",
    disableSortBy: true,
  },
  {
    Header: "Max. Primary Retention In Days",
    accessor: "backupPoliciesBoundary.maxPrimarySnapshotRetentionInDays",
    disableSortBy: true,
  },
  {
    Header: "Max. Replica Retention Quantity",
    accessor: "backupPoliciesBoundary.maxReplicaSnapshotRetentionQuantity",
    disableSortBy: true,
  },
  {
    Header: "Max. Replica Retention In Days",
    accessor: "backupPoliciesBoundary.maxReplicaSnapshotRetentionInDays",
    disableSortBy: true,
  },
  {
    Header: "Actions",
    accessor: "action",
    disableSortBy: true,
    Cell: ({ row }: Cell<CustomerBasic>) => {
      return <Actions customer={row.original} refetch={refetch} />;
    },
  },
];
